import { gql } from '@/store/helpers/axios.js'
import { merge, isEmpty } from 'lodash'

export default {
  async GET_RECHERCHE_LISTS ({ commit }) {
    // const filter = formData
    const query = `query cRMRechercheAdresslists (
          $order: [CRMRechercheAdresslistSortInput!]
          $where: CRMRechercheAdresslistFilterInput
        ) { 
        response: cRMRechercheAdresslists (where: $where order: $order) {
        field_001
        datum
        bezeichnung
        temporary_list
        cRMMitarbeiter {
          field_001
          vorname
          nachname
        }
      }
    }`

    const variables = {
      order: {
        datum: 'DESC'
      },
      where: {
        temporary_list: { eq: null }
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_RECHERCHELISTS', data.data.response)
    }

    return data
  },
  async GET_ADDRESS_BY_ID ({ commit }, addressId) {
    const query = `query cRMAddress ($id: Int!) {
      response: cRMAddress (field_001: $id) {
        field_001
        permalink
        profiles (where: { profiltypId: { eq: 2 } }) {
          field_001
          profiltypId
          cRMFundingProfileV2s {
            field_001
            datum
            closingdate
            comment
            moneyinCHF
            statusId
            investmentsStage
            investmentsTypeId
            cRMFundingJOINProfilProfileV2s{
              field_001
              profil_idId
              startupFundingID
              profile {
                field_001
                cRM_Adress_id
                cRMAddress {
                  field_001
                  company
                }
              }
            }
          }
        }
      }
    }`

    const variables = {
      id: Number(addressId)
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_RECHERCHE_PAGINATION ({ commit, dispatch }, { gqlOptions }) {
    const query = `query cRMRechercheAdresslisteAdressensPagination (
        $order: [CRMRechercheAdresslisteAdresseSortInput!],
        $where: CRMRechercheAdresslisteAdresseFilterInput,
        $take: Int,
        $skip: Int
      ) {
          response: cRMRechercheAdresslisteAdressensPagination (order: $order, where: $where, take: $take, skip: $skip) {
          items {
            field_001
            datum
            casequality
            sEMINARCasequality {
              field_001
              casequality
              laufnummer
            }
            cRMAddress {
              field_001
              company
              firstname
              lastname
              emailB1
              mobileB
              phoneB
              internetB
              cityB
              countryBId
              startupPhaseId
              incorporationDate
              permalink
              zipB
              tradeRegisterNr
              facebookB
              linkedInB
              twitterB
              instagramB
              similarwebB
              alexaB
              streetP
              zipP
              cityP
              countryPId
              mobileP
              phoneP
              emailP1
              emailP2
              facebookP
              linkedInP
              twitterP
              birthday
              position
              streetB
              emailB2
              sUTkrTradeRegUID
              unispinoffId
              technologyId
              universityFacultyIDId
              vKacademiclinkId
              legalFormId
              salutationId
              languageId
              educationId
              kantonId
              priovlabId
              prioXMasId,
              vKCaseStatus
              cRMAdresseJOINRolles {
                field_001
                rolle_id
              }
              cRMUniFaculty {
                field_001
                departementFaculty
                universityIDId
              }
            }
            vLABEvaluations {
              field_001
              comment
              cRMMitarbeiter {
                field_001
                vorname
                nachname
              }
              sEMINARCasequality {
                casequality
                field_001
                laufnummer
              }
            }
          }
          totalCount
        }
      }`

    const variables = {
      order: {
        datum: 'DESC'
      },
      where: {
        adresslisteID: { eq: gqlOptions.adresslisteId }
      }
    }

    if (!isEmpty(gqlOptions.order)) {
      variables.order = {}
    }

    const combinedVariables = merge(variables, gqlOptions)

    const { data } = await gql({ query, variables: combinedVariables })

    // load profiles seperately, because of performance issues when the query is too large and complex.
    if (data.data.response?.items) {
      const itemsData = data.data.response.items
      const batchSize = 100
      let index = 0

      while (index < itemsData.length) {
        const batch = itemsData.slice(index, index + batchSize)
        const crmAddressIds = []
        batch.map(item => {
          if (item.cRMAddress?.field_001) {
            crmAddressIds.push(item.cRMAddress.field_001)
          }
        })

        const profileData = await dispatch('GET_PROFILES_BY_ADRESSLIST', crmAddressIds)

        const mapListProfileData = new Map(profileData.data.response.map(item => [item.cRM_Adress_id, item]))

        data.data.response.items.forEach(item1 => {
          if (item1.cRMAddress) {
            item1.cRMAddress.profiles = item1.cRMAddress.profiles || []

            const field001 = item1.cRMAddress.field_001
            if (mapListProfileData.has(field001)) {
              const matchingItem2 = mapListProfileData.get(field001)
              item1.cRMAddress.profiles.push(matchingItem2)
            }
          }
        })

        index += batchSize
      }
    }

    return data
  },

  async GET_RECHERCHE_PAGINATION_V2 ({ commit, dispatch }, { options }) {
    const gqlOptions = options.gqlOptions
    const query = options.completeQuery

    const variables = {
      order: {
        datum: 'DESC'
      },
      where: {
        adresslisteID: { eq: gqlOptions.adresslisteId }
      }
    }

    if (!isEmpty(gqlOptions.order)) {
      variables.order = {}
    }

    const combinedVariables = merge(variables, gqlOptions)

    const { data } = await gql({ query, variables: combinedVariables })

    // load profiles seperately, because of performance issues when the query is too large and complex.
    if (options.isProfileVisible) {
      if (data.data.response?.items) {
        const itemsData = data.data.response.items
        const batchSize = 100
        let index = 0

        while (index < itemsData.length) {
          const batch = itemsData.slice(index, index + batchSize)
          const crmAddressIds = []
          batch.map(item => {
            if (item.cRMAddress?.field_001) {
              crmAddressIds.push(item.cRMAddress.field_001)
            }
          })

          const profileData = await dispatch('GET_PROFILES_BY_RECHERCHE', { profilesQuery: options.profilesQuery, crmAddressIds })

          const mapListProfileData = new Map(profileData.data.response.map(item => [item.cRM_Adress_id, item]))

          data.data.response.items.forEach(item1 => {
            if (item1.cRMAddress) {
              item1.cRMAddress.profiles = item1.cRMAddress.profiles || []

              const field001 = item1.cRMAddress.field_001
              if (mapListProfileData.has(field001)) {
                const matchingItem2 = mapListProfileData.get(field001)
                item1.cRMAddress.profiles.push(matchingItem2)
              }
            }
          })

          index += batchSize
        }
      }

      return data
    }

    return data
  },

  async GET_PROFILES_BY_RECHERCHE ({ commit }, options) {
    const query = options.profilesQuery

    const variables = {
      crmAdressIds: options.crmAddressIds
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async GET_PROFILES_BY_ADRESSLIST ({ commit }, crmAdressIds) {
    const query = `query profilesByBatchAdressId ($crmAdressIds: [Int!]!) { 
        response: profilesByBatchAdressId (crmAdressIds: $crmAdressIds) {
        field_001
        cRM_Adress_id
        profiltypId
        oneLiner_en
        vleadersAchievements
        description_open_en
        pEOPLEFemaleFounders
        pEOPLEMaleFounders
        totalEmployee
        changeDate
        turnOver
        ownedCopyrights
        ownedTrademarks
        pendingPatents
        grantedPatents
        peopleEPFLFac
        peopleEPFLLab
        peopleEPFLProf
        cRMFundingProfileV2s {
          field_001
          datum
          closingdate
          comment
          moneyinCHF
          statusId
          investmentsStage
          investmentsTypeId
        }
        pROFILProfilJOINCategories {
          field_001
          kategorie_idId
          pROFILCategory {
            field_001
            kategorieDE
          }
        }
        pROFILUntersttzungszuweisungs {
          field_001
          untersttzungId
        }
        pROFILProfilJOINReportingGroups{
          field_001
          profil_id
          pROFILReportingGroup{
            field_001
            reportingGroups
          }
        }
      }
    }`

    const variables = {
      crmAdressIds
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_MASTERDETAIL_FUNDINGS ({ commit }, profilId) {
    const query = `query cRMFundingProfileV2sNoPaging (
      $order: [CRMFundingProfileV2SortInput!]
      $where: CRMFundingProfileV2FilterInput
    ) { 
        response: cRMFundingProfileV2sNoPaging (where: $where order: $order) {
          field_001
          datum
          closingdate
          comment
          moneyinCHF
          statusId
          investmentsStage
          investmentsTypeId
          cRMFundingJOINProfilProfileV2s {
            field_001
            profil_idId
            startupFundingID
            profile {
              field_001
              cRM_Adress_id
              cRMAddress {
                field_001
                company
              }
            }
          }
      }
    }`

    const variables = {
      where: {
        startup_profil_id: { eq: Number(profilId) }
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_ADDRESSLISTS_BY_ID ({ commit }, { id }) {
    const query = `query cRMRechercheAdresslist ($id: Int!) {
      response: cRMRechercheAdresslist (field_001: $id) {
        bezeichnung
        datum
      }
    }`

    const variables = {
      id: Number(id)
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_ADDRESSLISTS', data.data.response)
    }

    return data
  },
  async GET_ADDRESSLISTS_BY_ID_POOL ({ commit }, { id }) {
    const query = `query cRMRechercheAdresslist ($id: Int!) {
      response: cRMRechercheAdresslist (field_001: $id) {
        bezeichnung
        datum
        cRMRechercheAdresslisteAdressen {
          cRMAddress {
            field_001
          }
        }
      }
    }`

    const variables = {
      id: Number(id)
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_ADDRESSLISTS', data.data.response)
    }

    return data
  },
  async GET_SAVEDLISTS_NAMES ({ commit }) {
      const query = `query cRMRechercheAdresslists (
        $order: [CRMRechercheAdresslistSortInput!]
        $where: CRMRechercheAdresslistFilterInput
      ) { 
          response: cRMRechercheAdresslists (where: $where order: $order) {
          field_001
          datum
          bezeichnung
          temporary_list
        }
      }`

      const variables = {
        order: {
          datum: 'DESC'
        },
        where: {
          temporary_list: { eq: null }
        }
      }

      const { data } = await gql({ query, variables })
      if (!data.errors) {
        const namesArray = []
        for (const name of data.data.response) {
          if (!namesArray.includes(name.bezeichnung)) {
            if (name.bezeichnung !== null && name.bezeichnung !== '') {
              namesArray.push(name.bezeichnung)
            }
          }
        }
        commit('SET_SAVEDLISTS_NAMES', namesArray)
      }

      return data
  },
  async GET_SAVELISTS ({ commit }, formData) {
    const query = `query cRMRechercheAdresslists (
      $order: [CRMRechercheAdresslistSortInput!]
      $where: CRMRechercheAdresslistFilterInput
    ) { 
        response: cRMRechercheAdresslists (where: $where order: $order) {
        field_001
        datum
        bezeichnung
        temporary_list
        cRMMitarbeiter {
          field_001
          vorname
          nachname
        }
        mAILVersands {
          field_001
          recherche_adressliste_idId
        }
      }
    }`

    const variables = {
        where: {
          bezeichnung: { contains: formData }
        }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_SAVEDLISTS', data.data.response)
    }

    return data
  },
  async GET_SAVED_ADDRESSDATA_BY_ADDRESSID ({ commit }, { id }) {
    const query = `query cRMAddress ($id: Int!) {
      response: cRMAddress (field_001: $id) {
          field_001
          sUTkrTradeRegUID
      }
    }`

    const variables = {
      id: Number(id)
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_AMBASSADORS_LISTS ({ commit }) {
    const query = `query cRMAdresseJOINRolles (
      $order: [CRMAdresseJOINRolleSortInput!]
      $where: CRMAdresseJOINRolleFilterInput
    ) { 
        response: cRMAdresseJOINRolles (where: $where order: $order) {
        field_001
        datum
        rolle_id
        crm_adress_id
        cRMAddress {
          field_001
          salutationId
          titel
          company
          company2
          division
          firstname
          lastname
          cityB
          priovlabId
          emailB1
          phoneB
          mobileB
          internetB
          linkedInB
          twitterB
          facebookB
          instagramB
          streetB
          zipB
          countryBId
          position
          organisationTypeId
        }
      }
    }`

    const variables = {
      order: {
        datum: 'DESC'
      },
      where: {
        rolle_id: { eq: 83 }
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_AMBASSADORSLIST', data.data.response)
    }

    return data
  },
  async UPDATE_ADDRESS ({ commit }, { id, formData }) {
    const {
      field_001, /* eslint-disable-line */
      company,
      firstname,
      lastname,
      emailB1,
      mobileB,
      phoneB,
      internetB,
      cityB,
      countryBId,
      startupPhaseId,
      incorporationDate,
      permalink,
      zipB,
      tradeRegisterNr,
      facebookB,
      linkedInB,
      twitterB,
      instagramB,
      similarwebB,
      alexaB,
      streetP,
      zipP,
      cityP,
      countryPId,
      mobileP,
      phoneP,
      emailP1,
      emailP2,
      facebookP,
      linkedInP,
      twitterP,
      birthday,
      position,
      streetB,
      emailB2,
      unispinoffId,
      technologyId,
      universityFacultyIDId,
      vKacademiclinkId,
      legalFormId,
      salutationId,
      languageId,
      educationId,
      kantonId,
      priovlabId,
      prioXMasId,
      sUTkrTradeRegUID,
      vKCaseStatus
    } = formData

    const query = `mutation updateCRMAddress($input: UpdateCRMAddressInput!) {
      updateCRMAddress(input: $input) {
        cRMAddress {
          field_001
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        field_001,
        company,
        firstname,
        lastname,
        emailB1,
        mobileB,
        phoneB,
        internetB,
        cityB,
        countryBId,
        startupPhaseId,
        incorporationDate,
        permalink,
        zipB,
        tradeRegisterNr,
        facebookB,
        linkedInB,
        twitterB,
        instagramB,
        similarwebB,
        alexaB,
        streetP,
        zipP,
        cityP,
        countryPId,
        mobileP,
        phoneP,
        emailP1,
        emailP2,
        facebookP,
        linkedInP,
        twitterP,
        birthday,
        position,
        streetB,
        emailB2,
        unispinoffId,
        technologyId,
        universityFacultyIDId,
        vKacademiclinkId,
        legalFormId,
        salutationId,
        languageId,
        educationId,
        kantonId,
        priovlabId,
        prioXMasId,
        sUTkrTradeRegUID,
        vKCaseStatus
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async UPDATE_PROFILE ({ commit }, { formData }) {
    const {
      field_001, /* eslint-disable-line */
      oneLiner_en, /* eslint-disable-line */
      description_open_en, /* eslint-disable-line */
      pEOPLEFemaleFounders,
      pEOPLEMaleFounders,
      peopleEPFLFac,
      peopleEPFLLab,
      peopleEPFLProf
    } = formData

    const query = `mutation updateProfile($input: UpdateProfileInput!) {
      updateProfile(input: $input) {
        profile {
          field_001
          oneLiner_en
          description_open_en
          pEOPLEFemaleFounders,
          pEOPLEMaleFounders,
          peopleEPFLFac,
          peopleEPFLLab,
          peopleEPFLProf
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        field_001,
        oneLiner_en,
        description_open_en,
        pEOPLEFemaleFounders: Number(pEOPLEFemaleFounders),
        pEOPLEMaleFounders: Number(pEOPLEMaleFounders),
        peopleEPFLFac,
        peopleEPFLLab,
        peopleEPFLProf
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async UPDATE_ADRESSLIST_ADRESSS ({ commit }, { formData }) {
    const {
      field_001, /* eslint-disable-line */
      casequality
    } = formData

    const query = `mutation updateCRMRechercheAdresslisteAdressen(
      $input: UpdateCRMRechercheAdresslisteAdressenInput!
    ) {
      updateCRMRechercheAdresslisteAdressen(input: $input) {
        cRMRechercheAdresslisteAdresse {
          field_001
          casequality
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        field_001,
        casequality
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async UPDATE_AMBASSADORS_ADDRESS ({ commit }, { id, formData }) {
    const {
      field_001, /* eslint-disable-line */
      salutationId,
      titel,
      company,
      company2,
      division,
      firstname,
      lastname,
      cityB,
      priovlabId,
      emailB1,
      phoneB,
      mobileB,
      internetB,
      linkedInB,
      twitterB,
      facebookB,
      instagramB,
      streetB,
      zipB,
      countryBId,
      position,
      organisationTypeId
    } = formData

    const query = `mutation updateCRMAddress($input: UpdateCRMAddressInput!) {
      updateCRMAddress(input: $input) {
        cRMAddress {
          field_001
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        field_001,
        salutationId,
        titel,
        company,
        company2,
        division,
        firstname,
        lastname,
        cityB,
        priovlabId,
        emailB1,
        phoneB,
        mobileB,
        internetB,
        linkedInB,
        twitterB,
        facebookB,
        instagramB,
        streetB,
        zipB,
        countryBId,
        position,
        organisationTypeId
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_EVALUATIONS ({ commit }, addressId) {
    const query = `query vLABEvaluations (
      $where: VLABEvaluationFilterInput
      $order: [VLABEvaluationSortInput!]
    ) {
      vLABEvaluations (where: $where, order: $order) {
        field_001
        datum
        comment
        mitarbeiter_id
        cRMMitarbeiter {
          field_001
          vorname
          nachname
        }
        sEMINARCasequality {
          casequality
          field_001
        }
      }
    }`

    const variables = {
      where: {
        cRM_Recherche_Adressliste_id: { eq: addressId }
      },
      order: {
        field_001: 'DESC'
      }
    }

    const { data } = await gql({ query, variables })

    return data.data.vLABEvaluations
  },
  async UPDATE_EVALUATION ({ commit }, { formData }) {
    const {
      id,
      comment,
      evulationId,
      addressId
    } = formData

    const query = `mutation updateVLABEvaluation ($input: UpdateVLABEvaluationInput) {
      updateVLABEvaluation(input: $input) {
        vLABEvaluation {
          field_001
          comment
        }
      }
    }`

    const variables = {
      input: {
        field_001: id,
        comment,
        evaluation_id: evulationId,
        cRM_Recherche_Adressliste_id: addressId,
        datum: new Date().toISOString()
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async CREATE_EVALUATION ({ commit }, { formData }) {
    const {
      comment,
      evulationId,
      addressId
    } = formData

    const query = `mutation createVLABEvaluation ($input: CreateVLABEvaluationInput) {
      createVLABEvaluation(input: $input) {
        vLABEvaluation {
          field_001
          comment
        }
      }
    }`

    const variables = {
      input: {
        comment,
        evaluation_id: evulationId,
        cRM_Recherche_Adressliste_id: addressId,
        datum: new Date().toISOString()
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async GET_MEILISEARCHCONTENT ({ commit }) {
    const query = `query profiles (
      $order: [ProfileSortInput!]
      $where: ProfileFilterInput
    ) { 
        response: profiles (where: $where order: $order) {
        id: field_001
        datum
        cRM_Adress_id
        vleadersproblemopportunity
        vleadersProductservice
        vleadersTechnologie
        vleadersTargetcustomers
        vleadersMarketcompetition
        vleadersTeam
        vleadersAchievements
        vleadersFinancials
        closingStep3
        cRMAddress {
          company
        }
      }
    }`

    const variables = {
      where: {
        vleadersproblemopportunity: {
          neq: null
        }
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_MEILISEARCHCONTENT', data.data.response)
    }

    return data
  },

  async CREATE_LIST ({ commit }, { formData }) {
    const {
      title,
      addressID
    } = formData

    const query = `mutation createCRMRechercheAdresslist ($input: CreateCRMRechercheAdresslistInput) {
      createCRMRechercheAdresslist(input: $input) {
        response: cRMRechercheAdresslist {
          field_001
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        bezeichnung: title,
        user_adresse_id: addressID
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async CREATE_LIST_AND_ADRESSES ({ commit }, { formData }) {
    const {
      title,
      addressID,
      arrayOfIds,
      unicSession
    } = formData

    const query = `mutation createCRMRechercheAdresslistWithAdresses ($input: CreateCRMRechercheAdresslistInput) {
      createCRMRechercheAdresslistWithAdresses(input: $input) {
        response: cRMRechercheAdresslist {
          field_001
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        bezeichnung: title,
        user_adresse_id: addressID,
        addressIds: arrayOfIds,
        unicSession: unicSession
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async ADD_ADDRESS_TO_LIST ({ commit }, { formData }) {
    const {
      addressListID,
      crmAddressID
    } = formData

    const query = `mutation createCRMRechercheAdresslisteAdressen ($input: CreateCRMRechercheAdresslisteAdressenInput) {
      createCRMRechercheAdresslisteAdressen(input: $input) {
        response: cRMRechercheAdresslisteAdresse {
          field_001
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        adresslisteID: addressListID,
        crm_adresse_idId: crmAddressID
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async DELETE_RECHERCHE_ADRESSLIST ({ commit }, addressId) {
    const query = `mutation deleteCRMRechercheAdresslistAndAdresses($id: Int!) {
      deleteCRMRechercheAdresslistAndAdresses(field_001: $id) {
        ok
      }
    }`

    const variables = {
      id: addressId
    }

    const { data } = await gql({ query, variables })

    return data
  },

  async CREATE_OR_DELETE_ROLE ({ commit }, { formData }) {
    const {
      crmAdressId,
      roleId
    } = formData

    const query = `mutation createOrDeleteCRMAdresseJOINRolleCustom ($input: CreateCRMAdresseJOINRolleInput!) {
      response: createOrDeleteCRMAdresseJOINRolleCustom(input: $input) {
        response: cRMAdresseJOINRolle {
          field_001
          crm_adress_id
          rolle_id
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        crm_adress_id: crmAdressId,
        rolle_id: roleId
      }
    }

    const { data } = await gql({ query, variables })

    return data.data.response
  }
}
